import { QueryClient, type QueryClientConfig } from "@tanstack/react-query";

/**
 * Default TanStack Query client for Platform consumers.
 * Native Systems may pass their own config; this is a sensible shared baseline,
 * not a place for System-specific query keys or invalidation rules (AR-04).
 */
export function createPlatformQueryClient(
  config: QueryClientConfig = {},
): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
        ...config.defaultOptions?.queries,
      },
      mutations: {
        retry: 0,
        ...config.defaultOptions?.mutations,
      },
    },
    ...config,
  });
}
